export default "__VITE_ASSET__16777ece__"